module.exports = __webpack_public_path__ + "static/media/river-sumida.5b4ac407.bmp";